import React from "react";

/**
 * Small, opinionated read-only table for agency data panels.
 *   columns: [{ key, label, render?(row), align? }]
 *   rows:    array of objects
 */
export default function DataTable({ columns, rows, empty = "No data." }) {
  if (!rows || rows.length === 0) return <div className="empty">{empty}</div>;
  return (
    <table className="data">
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key} style={c.align === "right" ? { textAlign: "right" } : undefined}>
              {c.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i}>
            {columns.map((c) => (
              <td key={c.key} style={c.align === "right" ? { textAlign: "right" } : undefined}>
                {c.render ? c.render(r) : r[c.key] ?? "—"}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
